import { combineReducers, createStore } from "redux";
import reducers from "./reducers";
import react_tools_reducers from "@acri-tools/react-tools/redux/reducers";
import react_tools_store from '@acri-tools/react-tools/redux';

const store = createStore(
    combineReducers({
        ...reducers,
        ...react_tools_reducers
    })
);
react_tools_store.store = store

export default store;